'use client';

import { useBrand } from '@curology/ui-components-web/brand/context';

import ContactSupportError from '@/components/global/errors/contactSupportError';
import ErrorNavBar from '@/components/global/errors/errorNavBar';

export const Error = () => {
  const brand = useBrand();
  return (
    <>
      <ErrorNavBar />
      <ContactSupportError />
    </>
  );
};

export default Error;
